import React, { Component, createRef } from "react";
import Slider from "react-slick";
import "./small-image.css";

class SmallImages extends Component {
  constructor(props) {
    super(props);
    this.videoRef = createRef();
    this.canvasRef = createRef();
    this.state = {
      nav2: this.slider2,
      thumbnail: null,
    };
  }
  // componentDidMount() {
  //   const video = this.videoRef.current;
  //   const canvas = this.canvasRef.current;
  //   if (!video) return;
  //   // When metadata is loaded, seek to 1s
  //   video.addEventListener("loadeddata", () => {
  //     try {
  //       video.currentTime = 1;
  //     } catch (err) {
  //       console.error("Error seeking video:", err);
  //     }
  //   });

  //   // When seeking finishes, draw frame on canvas
  //   video.addEventListener("seeked", () => {
  //     try {
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //       const imgUrl = canvas.toDataURL("image/jpeg");
  //       this.setState({ thumbnail: imgUrl, loading: false });
  //     } catch (err) {
  //       console.error("Thumbnail generation failed:", err);
  //     }
  //   });

  //   this.setState({
  //     nav2: this.slider2,
  //   });
  // }

  componentDidMount() {
    const video = this.videoRef.current;
    const canvas = this.canvasRef.current;
    if (!video) return;

    video.addEventListener("loadedmetadata", () => {
      video.currentTime = 1;
    });

    video.addEventListener("seeked", () => {
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imgUrl = canvas.toDataURL("image/jpeg");
      this.setState({ thumbnail: imgUrl, loading: false });
    });

    // Ensure video can seek on mobile
    video.muted = true;
    video.play().catch((err) => console.warn("Video play prevented:", err));

    this.setState({ nav2: this.slider2 });
  }

  render() {
    const { item, settings } = this.props;

    // slick ta muloto accurate kaj kore na because of maxwidth deya ja small image te tar jonno.
    // r reload neyaite hobe live kaj kore na media query
    var productsnav = {
      arrows: true,
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: true,
      prevArrow: <SamplePrevArrow />,
      nextArrow: <SampleNextArrow />,
      edgeFriction: 0,
      responsive: [
        { breakpoint: 375, settings: { slidesToShow: 4 } },
        { breakpoint: 450, settings: { slidesToShow: 5 } },
        { breakpoint: 1024, settings: { slidesToShow: 5 } },
        { breakpoint: 1500, settings: { slidesToShow: 5 } },
        { breakpoint: 1600, settings: { slidesToShow: 6 } },
        { breakpoint: 25000, settings: { slidesToShow: 7 } },
        { breakpoint: 100000, settings: "unslick" },
      ],
    };

    let renderableArray = item.pictures;

    return (
      <div className="small-image-container-div">
        <Slider
          {...productsnav}
          asNavFor={this.props.navTwo}
          ref={(slider) => (this.slider2 = slider)}
          className="slider-nav"
        >
          {this.state.thumbnail && (
            <div>
              <img
                src={this.state.thumbnail} // make sure each thumbnail is generated individually
                alt="Video Thumbnail"
                className="img-fluid"
                style={{
                  maxHeight: 60,
                  minHeight: 60,
                  maxWidth: 60,
                  minWidth: 60,
                  border: "2px solid gainsboro",
                  borderRadius: 5,
                }}
                onClick={() => this.props.clickOnVideo(this.state.thumbnail)}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  background: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: "none",
                }}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderLeft: "10px solid white",
                    borderTop: "6px solid transparent",
                    borderBottom: "6px solid transparent",
                  }}
                ></div>
              </div>
            </div>
          )}

          {renderableArray.map((vari, index) => (
            <div
              key={index}
              onClick={() => this.props.clickOnColorVariant(vari)}
              style={{
                cursor: "pointer",
                overflow: "hidden",
              }}
            >
              <img
                src={`${vari}_60x60.webp`}
                key={index}
                alt=""
                className="img-fluid"
                style={{
                  maxHeight: 60,
                  minHeight: 60,
                  maxWidth: 60,
                  minWidth: 60,
                  border: "2px solid gainsboro",
                  borderRadius: 5,
                }}
              />
            </div>
          ))}
        </Slider>
        <video
          ref={this.videoRef}
          src={item.videos[0].Url}
          style={{ width: 0, height: 0, visibility: "hidden" }}
          crossOrigin="anonymous"
          muted
        />
        <canvas
          ref={this.canvasRef}
          width={400}
          height={400}
          style={{ display: "none" }}
        />
      </div>
    );
  }
}

export default SmallImages;

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "gainsboro",
        minHeight: "94%",
        maxHeight: "94%",
        marginTop: "2px",
        borderRadius: "3px",
        border: "2px solid gainsboro",
        color: "black",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "gainsboro",
        minHeight: "94%",
        maxHeight: "94%",
        marginTop: "2px",
        borderRadius: "3px",
        border: "2px solid gainsboro",
        color: "black",
      }}
      onClick={onClick}
    />
  );
}
